import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys',
  pure: false
})
/**
 * Extract object keys pipe
 */
export class KeysPipe implements PipeTransform {
  transform(value: object): string[] {
    if (!value) {
      return [];
    }
    return Object.keys(value);
  }
}
